import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Pedido } from "../../services/ventas/ventas.types";

export type VentasState = {
  ventas: Pedido[];
  loading: boolean;
};

const initialState: VentasState = {
  ventas: [],
  loading: false,
};

const ventasSlice = createSlice({
  name: "ventas",
  initialState,
  reducers: {
    clearVentas: (state) => {
      state.ventas = [];
      state.loading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setVentas: (state, action: PayloadAction<Pedido[]>) => {
      state.ventas = action.payload;
      state.loading = false;
    },
  },
});

export default ventasSlice;
export const { clearVentas, setLoading, setVentas } = ventasSlice.actions;
